import axios from 'axios';
import {loginreq, req} from './axiosFun';

// 登录接口
export const login = (params) => {
  return loginreq("post", "/api/apps/login", params)
};
export const getCodes = (params) => {
  return loginreq("post", "/api/apps/sms", params)
};
// 退出接口
export const loginout = () => {
  return axios.delete("/api/login").then(res => res.data)
};

//首页相关信息获取
export const home = () => {
  return req("post", "/api/apps")
};

//获取机油剩余时间
export const remainOil = () => {
  return req("post", "/api/apps/oil")
};

//基本设置
export const basicSetting = (params) => {
  return req("post", "/api/apps/setting", params)
};
//广告
export const ad = (params) => {
  return req("get", "/api/apps/ad", params)
};
export const adDelete = (params) => {
  return req("post", "/api/apps/adDelete", params)
};
export const adSave = (params) => {
  return req("post", "/api/ad/save", params)
};
//用户组
export const groups = (params) => {
  return req("post", "/api/auth/userGroup", params)
};
//用户组添加/修改
export const groupSave = (params) => {
  return req("post", "/api/auth/save", params)
};
//用户组添加/修改
export const groupDelete = (params) => {
  return req("post", "/api/auth/destroy", params)
};
//管理员
export const manager = (params) => {
  return req("post", "/api/auth/index", params)
};
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => {
  return axios.post("/api/auth/menu", params)
};

//添加/修改管理员白名单
export const allWhite = (params) => {
  return req("post", "/api/manager/all", params)
};
//添加/修改管理员白名单
export const saveWhite = (params) => {
  return req("post", "/api/manager/save", params)
};
//添加/修改管理员白名单
export const deleteWhite = (params) => {
  return req("post", "/api/manager/destroy", params)
};
export const userGroup = () => {
  return req("post", "/api/auth/userGroup")
};
export const saveManager = (params) => {
  return req("post", "/api/auth/saveAdmin", params)
};
export const deleteManager = (params) => {
  return req("post", "/api/auth/destroyAdmin", params)
};
export const notice = (params) => {
  return req("post", "/api/systemInfo", params)
};
export const noticeSave = (params) => {
  return req("post", "/api/systemInfo/save", params)
};
export const noticeDelete = (params) => {
  return req("post", "/api/systemInfo/destroy", params)
};
export const allMenu = (params) => {
  return req("post", "/api/auth/menus", params)
};
export const menus = (params) => {
  return req("post", "/api/auth/menu", params)
};
export const menuSave = (params) => {
  return req("post", "/api/auth/menuSave", params)
};
export const menuDelete = (params) => {
  return req("post", "/api/auth/menuDelete", params)
};
export const selectedMenu = (params) => {
  return req("post", "/api/auth/selectedMenu", params)
};
export const userMenuSave = (params) => {
  return req("post", "/api/auth/saveMenu", params)
};
export const white = (params) => {
  return req("post", "/api/manager", params)
};
export const map = () => {
  return req("post", "/api/devices/map")
};
export const saveGeneralDevice = (params) => {
  return req("post", "/api/devices/save", params)
};
export const saveGeneralMemo = (params) => {
  return req("post", "/api/devices/saveMemo", params)
};
export const saveGeneralMove = (params) => {
  return req("post", "/api/devices/move", params)
};
export const operate = (params) => {
  return req("post", "/api/devices/operate", params)
};
export const lockGeneral = (params) => {
  return req("post", "/api/devices/lockMore", params)
};
export const unlockGeneral = (params) => {
  return req("post", "/api/devices/unlock", params)
};
export const remoteLockGeneral = (params) => {
  return req("post", "/api/devices/remoteLockMore", params)
};
export const remoteUnLockGeneral = (params) => {
  return req("post", "/api/devices/remoteUnLockMore", params)
};
export const deleteGeneralDevice = (params) => {
  return req("post", "/api/devices/delete", params)
};
export const devices = (params) => {
  return req("post", "/api/devices", params)
};
export const weather = (params) => {
  return req("post", "/api/devices/weatherDevice", params)
};
export const saveWeather = (params) => {
  return req("post", "/api/devices/saveWeather", params)
};

export const deleteWeather = (params) => {
  return req("post", "/api/devices/deleteWeather", params)
};

export const saveWeatherMemo = (params) => {
  return req("post", "/api/devices/saveWeatherMemo", params)
};
export const saveWeatherMove = (params) => {
  return req("post", "/api/devices/moveWeather", params)
};

export const repairHistory = (params) => {
  return req("post", "/api/repair/history", params)
};

export const repairDispose = (params) => {
  return req("post", "/api/repair/dispose", params)
};

export const agreement = () => {
  return req("post", "/api/agreement")
};
export const deleteAgreement = (params) => {
  return req("post", "/api/agreement/delete", params)
};
export const saveAgreement = (params) => {
  return req("post", "/api/agreement/save", params)
};
export const course = (params) => {
  return req("post", "/api/course", params)
};
export const saveCourse = (params) => {
  return req("post", "/api/course/save", params)
};
export const deleteCourse = (params) => {
  return req("post", "/api/course/delete", params)
};
export const alarm = (params) => {
  return req("post", "/api/alarm", params)
};
export const getPie = (params) => {
  return req("post", "/api/pie", params)
};
//查看操作日志列表
export const logs = (params) => {
  return req("post", "/api/logs", params)
};
//查看微信用户列表
export const wechat = (params) => {
  return req("post", "/api/wechat", params)
};
//设置角色
export const setUserRole = (params) => {
  return req("post", "/api/wechat/setRole", params)
};
//设置角色
export const lockUserDevice = (params) => {
  return req("post", "/api/devices/lockDevice", params)
};
//设置为某个管理员名下的操作员
export const setOperator = (params) => {
  return req("post", "/api/wechat/operator", params)
};
//设置售后
export const setRepairPerson = (params) => {
  return req("post", "/api/wechat/repair", params)
};
//查看管理员
export const wechatManager = (params) => {
  return req("post", "/api/wechat/manager", params)
};
//保存管理员
export const wechatSaveManager = (params) => {
  return req("post", "/api/wechat/saveWechatUser", params)
};
//删除管理员
export const wechatDeleteManager = (params) => {
  return req("post", "/api/wechat/deleteUser", params)
};
//查看操作员
export const searchOperator = (params) => {
  return req("post", "/api/wechat/operators", params)
};


//查看授权列表
export const searchApiAuth = (params) => {
  return req("post", "/api/authApi", params)
};
//保存授权账号
export const saveApiAuth = (params) => {
  return req("post", "/api/authApi/save", params)
};
//删除授权账号
export const deleteApiAuth = (params) => {
  return req("post", "/api/authApi/destroy", params)
};

//查看所有微信管理员
export const wechatManagers = (params) => {
  return req("post", "/api/wechat/wechatManagers", params)
};










// WEBPACK FOOTER //
// ./src/api/userMG.js